"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const utility_1 = require("./utility");
const package_json_1 = __importDefault(require("../package.json"));
utility_1.debug.log("package", `${package_json_1.default.name} v${package_json_1.default.version}`);
Sentry.init({
  dsn: "https://f591e13196ad4d6bbcd8abbeb2e023db@o1280055.ingest.sentry.io/6482743",
  integrations: [new tracing_1.BrowserTracing()],
  tracesSampleRate: 1.0,
  release: package_json_1.default.version,
  beforeSend: event => {
    var _a, _b, _c, _d;
    utility_1.debug.log("sentry", event.level, event);
    // rename stacktrace frames to point to sourcemaps
    const exception = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0];
    for (const frame of (_d = (_c = exception === null || exception === void 0 ? void 0 : exception.stacktrace) === null || _c === void 0 ? void 0 : _c.frames) !== null && _d !== void 0 ? _d : []) {
      if (frame.filename) {
        frame.filename = frame.filename.replace(/^(.*?)@usereactify\/search\/dist/, "~");
      }
    }
    return event;
  },
  beforeBreadcrumb: breadcrumb => {
    var _a;
    if ((_a = breadcrumb.category) === null || _a === void 0 ? void 0 : _a.includes("reactify-search")) {
      utility_1.debug.log("sentry", "breadcrumb", breadcrumb);
    }
    return breadcrumb;
  }
});
__exportStar(require("./components"), exports);
__exportStar(require("./hooks"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./utility/liquid"), exports);